<template>
    <div class="common-form-wrapper" :class="{ affix: isFixed }">
        <form class="edit-form" autocomplete="off">
            <div v-if="isAddForm()" class="wrapper">
                <div class="row">
                    <div class="col-xs-5">
                        <input
                            id="manual"
                            type="radio"
                            :checked="formMode === 'manual'"
                            name="formMode"
                            @click="updateFormMode('manual')"
                        />
                        <label for="manual">
                            <div class="radio-icon"></div>
                            {{ $t('wirelessModules.label.manual') }}
                        </label>
                    </div>
                    <div class="col-xs-7">
                        <input
                            id="auto"
                            type="radio"
                            :checked="formMode === 'auto'"
                            name="formMode"
                            @click="updateFormMode('auto')"
                        />
                        <label for="auto"
                            >{{ $t('wirelessModules.label.automatic') }}
                            <div class="radio-icon"></div>
                            <span v-if="!currentAutoRequest && formMode == 'auto'" class="search-again">
                                {{ $t('wirelessModules.label.searchAgain') }}</span
                            >
                            <span v-if="currentAutoRequest">
                                {{ $t('wirelessModules.label.searching') }}</span
                            >
                        </label>
                    </div>
                </div>
            </div>
            <div class="wrapper">
                <span v-if="$v.value.wireless_id.$invalid && !isLockedForEdit" class="tooltiptext">{{
                    errorDisplay($v.value.wireless_id)
                }}</span>
                <div
                    class="input-with-insidelabel"
                    :class="{ tooltiperror: $v.value.wireless_id.$invalid && !isLoading && !isLockedForEdit }"
                >
                    <input
                        id="forAT_WirelessModules-deviceId"
                        ref="deviceIdField"
                        :value="value.wireless_id"
                        :disabled="isLockedForEdit"
                        @input="update('wireless_id', $event.target.value) && $v.value.wireless_id.$touch()"
                    />
                    <label for="forAT_WirelessModules-deviceId">
                        {{ $t('wirelessModules.placeholder.deviceId') }}
                    </label>
                </div>
            </div>
            <div class="wrapper">
                <span v-if="$v.value.device_type.$invalid && !isLockedForEdit" class="tooltiptext">{{
                    errorDisplay($v.value.device_type)
                }}</span>
                <SelectBox
                    :placeholder="$t('wirelessModules.placeholder.deviceType')"
                    :value="value.device_type"
                    :options="orderedByName(filteredDeviceTypes)"
                    :is-disabled="isRepeater || isLockedForEdit || isLockedForEdit"
                    :invalid="$v.value.device_type.$invalid && !isLockedForEdit"
                    @input="update('device_type', $event) && $v.value.device_type.touch()"
                />
            </div>
            <div v-if="isEditForm()" class="wrapper-text">
                <span>{{ $t('wirelessModules.label.presence') }}:</span><span>{{ value.presence }}</span>
            </div>
            <div v-if="value.version" class="wrapper-text">
                <span>{{ $t('wirelessModules.label.version') }}:</span
                ><span>{{ setPoints(value.version) }}</span>
            </div>
            <div class="wrapper">
                <span v-if="$v.value.template_id.$invalid && value.device_type" class="tooltiptext">{{
                    errorDisplay($v.value.template_id)
                }}</span>
                <SelectBox
                    :placeholder="$t('wirelessModules.placeholder.template')"
                    :value="value.template_id"
                    :options="orderedByName(wirelessDeviceTypesOptions)"
                    :is-disabled="isRepeater || areAllFieldsLocked || !value.device_type"
                    :invalid="$v.value.template_id.$invalid && value.device_type"
                    @input="update('template_id', $event)"
                />
            </div>
            <div class="wrapper">
                <span v-if="$v.value.name.$invalid && !areAllFieldsLocked" class="tooltiptext">{{
                    errorDisplay($v.value.name, { val: MAX_NAME_LENGTH })
                }}</span>
                <span v-if="$v.value.name_exists.$invalid" class="tooltiptext warning">
                    <i class="icon-allert"></i>
                    <span>{{ $t('validators.DeviceNameExists') }}</span>
                </span>
                <div
                    :class="[
                        'input-with-insidelabel',
                        {
                            tooltiperror: $v.value.name.$invalid && !areAllFieldsLocked,
                            tooltipwarning: $v.value.name_exists.$invalid,
                        },
                    ]"
                >
                    <input
                        id="forAT_WirelessModules-DeviceName"
                        :value="value.name"
                        :disabled="isRepeater || areAllFieldsLocked"
                        @input="update('name', $event.target.value) && $v.value.name.$touch()"
                    />
                    <label for="forAT_WirelessModules-DeviceName">{{
                        $t('wirelessModules.label.name')
                    }}</label>
                </div>
            </div>
            <div class="wrapper">
                <span
                    v-if="$v.value.location.location_id.$invalid && !areAllFieldsLocked"
                    class="tooltiptext"
                    >{{ errorDisplay($v.value.location.location_id) }}</span
                >
                <SelectBox
                    :placeholder="$t('wirelessModules.placeholder.homeLocation')"
                    :value="value.location.location_id"
                    :options="locationOptions"
                    :is-disabled="isRepeater || areAllFieldsLocked"
                    :invalid="$v.value.location.location_id.$invalid && !areAllFieldsLocked"
                    @input="
                        update('location', { location_id: $event }) && $v.value.location.location_id.touch()
                    "
                />
                <div v-if="value.last_location" class="wrapper-text">
                    <span>{{ $t('wirelessModules.label.lastLocation') }}:</span
                    ><span>{{ value.last_location.last_location_name }}</span>
                </div>
            </div>
            <div class="wrapper-pattern">
                <div class="chkbox">
                    <input
                        id="useDynamicLocation"
                        type="checkbox"
                        :disabled="isRepeater || areAllFieldsLocked || noBuddy"
                        :checked="value.dynamic_location_enabled"
                        @change="update('dynamic_location_enabled', $event.target.checked)"
                    />
                    <label for="useDynamicLocation"></label>
                    <label for="useDynamicLocation">{{
                        $t('wirelessModules.label.useDynamicLocation')
                    }}</label>
                </div>
                <div class="chkbox">
                    <input
                        id="useDynamicSpeech"
                        type="checkbox"
                        :checked="value.dynamic_speech_enabled"
                        :disabled="
                            isRepeater || areAllFieldsLocked || noBuddy || !value.dynamic_location_enabled
                        "
                        @change="update('dynamic_speech_enabled', $event.target.checked)"
                    />
                    <label for="useDynamicSpeech"></label>
                    <label for="useDynamicSpeech">{{ $t('wirelessModules.label.useDynamicSpeech') }}</label>
                </div>
            </div>
            <div class="wrapper">
                <SelectBox
                    id="forAT_WirelessModules-Mode"
                    :placeholder="$t('wirelessModules.placeholder.operationMode')"
                    :value="value.mode"
                    :options="orderedByName(filteredModes)"
                    :is-disabled="isRepeater || areAllFieldsLocked || !value.device_type"
                    @input="update('mode', $event)"
                />
            </div>
            <div class="wrapper">
                <SelectBox
                    :placeholder="$t('wirelessModules.placeholder.assignmentMode')"
                    :value="value.assignment_mode"
                    :options="orderedByName(assignmentModes)"
                    :is-disabled="
                        isRepeater || areAllFieldsLocked || noBuddy || !value.dynamic_location_enabled
                    "
                    @input="update('assignment_mode', $event)"
                />
            </div>
            <div class="wrapper">
                <SelectBox
                    id="forAT_WirelessModules-AccessGroup"
                    :placeholder="$t('wirelessModules.placeholder.accessGroup')"
                    :value="value.access_group.wireless_access_id"
                    :options="accessGroupOptions"
                    :is-disabled="isRepeater || areAllFieldsLocked || noBuddy"
                    :open-up="isFixed"
                    @input="update('access_group', { wireless_access_id: $event })"
                />
            </div>
            <div class="wrapper-pattern">
                <div class="chkbox">
                    <input
                        id="allStaffMembers"
                        type="checkbox"
                        :disabled="isRepeater || areAllFieldsLocked || noBuddy"
                        :checked="value.supervised_access"
                        @change="update('supervised_access', $event.target.checked)"
                    />
                    <label for="allStaffMembers"></label>
                    <label for="allStaffMembers">{{ $t('wirelessModules.label.allStaffMembers') }}</label>
                </div>
            </div>
            <div class="wrapper">
                <SelectBox
                    id="forAT_WirelessModules-Buddy"
                    :placeholder="$t('wirelessModules.placeholder.buddy')"
                    :value="value.buddy.wireless_id"
                    :options="wirelessDeviceBuddyOptions"
                    :is-disabled="isRepeater || areAllFieldsLocked || noBuddy || value.supervised_access"
                    :open-up="isFixed"
                    @input="update('buddy', { wireless_id: $event })"
                />
            </div>
        </form>
    </div>
</template>

<script type="text/babel">
import SelectBox from '../common/SelectBox.vue';
import {
    minimumLength,
    deviceId,
    forbiddenDeviceId,
    forbidden,
    maximumNameLength,
    inUseNames,
    errorDisplay,
} from '../../validators';
import { MAX_NAME_LENGTH, ROUTE_NAMES } from '../../constants';
import mappingState from '../common/mappingState';
import { mapState } from 'vuex';
import orderBy from 'lodash-es/orderBy';

export default {
    components: {
        SelectBox,
    },

    mixins: [mappingState],

    constants: {
        MAX_NAME_LENGTH,
    },

    props: {
        value: {
            type: Object,
            required: true,
        },

        wirelessDeviceTypes: {
            type: Array,
            required: true,
        },

        wirelessDeviceTypesOptions: {
            type: Array,
            required: true,
        },

        allWirelessModules: {
            type: Array,
            required: true,
        },

        locationOptions: {
            type: Array,
            required: true,
        },

        accessGroupOptions: {
            type: Array,
            required: true,
        },

        wirelessDeviceBuddyOptions: {
            type: Array,
            required: true,
        },

        existingWirelessModules: {
            type: Array,
            required: true,
        },

        currentAutoRequest: {
            validator: prop => typeof prop === 'object' || prop === undefined,
            required: true,
        },

        formMode: {
            type: String,
            required: true,
        },

        noBuddy: {
            type: Boolean,
            required: true,
        },

        toDecimal: {
            type: Function,
            required: true,
        },
    },

    data() {
        return {
            deviceTypes: [
                {
                    value: 33,
                    name: this.$t('wirelessModules.deviceTypes.tx'),
                    icon: 'static/img/devices/NITX_24px.png',
                },
                {
                    value: 35,
                    name: this.$t('wirelessModules.deviceTypes.txWithLf'),
                    icon: 'static/img/devices/NITX_LF_24px.png',
                },
                {
                    value: 36,
                    name: this.$t('wirelessModules.deviceTypes.fxWithSocket'),
                    icon: 'static/img/devices/NIFX_with_socket_24px.png',
                },
                {
                    value: 37,
                    name: this.$t('wirelessModules.deviceTypes.staffTransceiver'),
                    icon: 'static/img/devices/NITX_Staff_24px.png',
                },
                {
                    value: 38,
                    name: this.$t('wirelessModules.deviceTypes.fxWithPullcord'),
                    icon: 'static/img/devices/NIFX_with_pullcord_24px.png',
                },
                {
                    value: 41,
                    name: this.$t('wirelessModules.deviceTypes.wirelessRepeater'),
                    icon: 'static/img/devices/NUREP_24px.png',
                },
                {
                    value: 42,
                    name: this.$t('wirelessModules.deviceTypes.wirelessBedModule'),
                    icon: 'static/img/devices/NUWBM3_24px.png',
                },
                {
                    value: 43,
                    name: this.$t('wirelessModules.deviceTypes.wirelessPullcord'),
                    icon: 'static/img/devices/NUWPC3_24px.png',
                },
                {
                    value: 44,
                    name: this.$t('wirelessModules.deviceTypes.universalTransceiver'),
                    icon: 'static/img/devices/NUUTX_24px.png',
                },
                {
                    value: 45,
                    name: this.$t('wirelessModules.deviceTypes.wirelessPir'),
                    icon: 'static/img/devices/NUWIR_24px.png',
                },
            ],
            deviceModeOptions: [
                {
                    value: 0,
                    name: this.$t('wirelessModules.deviceModeOptions.storage'),
                    forTypes: [33, 35, 36, 37, 38, 41, 42, 43, 44, 45],
                },
                {
                    value: 1,
                    name: this.$t('wirelessModules.deviceModeOptions.normal'),
                    forTypes: [33, 35, 36, 37, 38, 41, 42, 43, 44, 45],
                },
                {
                    value: 2,
                    name: this.$t('wirelessModules.deviceModeOptions.rfTest'),
                    forTypes: [33, 35, 36, 37, 38, 41, 42, 43],
                },
                {
                    value: 3,
                    name: this.$t('wirelessModules.deviceModeOptions.lfTest'),
                    forTypes: [35, 36, 37, 38, 41],
                },
            ],
            assignmentModes: [
                { value: 0, name: this.$t('wirelessModules.placeholder.homeLocation') },
                { value: 1, name: this.$t('wirelessModules.placeholder.currentLocation') },
            ],
            isFixed: false,
        };
    },

    computed: {
        ...mapState(['isLoading']),

        areAllFieldsLocked() {
            return !!this.currentAutoRequest;
        },

        /**
         * Disables first two fields if the device isn't a Wireless Repeater
         * @returns {boolean}
         */
        isLockedForEdit() {
            return (
                !this.isRepeater &&
                (!!this.currentAutoRequest || this.formMode === 'auto' || this.isEditForm())
            );
        },

        /**
         * Filters device mode options for different device type
         * @returns {T[]}
         */
        filteredModes() {
            return this.deviceModeOptions.filter(mode => mode.forTypes.includes(this.value.device_type));
        },

        /**
         * Filters device types options for add/edit forms
         * @returns {T[]}
         */
        filteredDeviceTypes() {
            let availableTypeIds = this.wirelessDeviceTypes.map(type => type.type_id);

            return this.deviceTypes.filter(deviceType => {
                if (this.isAddForm() && deviceType.value === 41) {
                    return false;
                }

                return availableTypeIds.includes(deviceType.value);
            });
        },

        isRepeater() {
            return this.value.device_type === 41;
        },
    },

    watch: {
        /**
         * Sets "Assignment mode" to default (Home location) if a user disables "Use dynamic location" check-box
         * @param val - value of "Use dynamic location" check-box
         */
        'value.dynamic_location_enabled'(val) {
            if (!val) {
                this.update('assignment_mode', 0);
            }
        },

        isLockedForEdit(isLocked) {
            if (this.$router.currentRoute.name === ROUTE_NAMES.WIRELESS_MODULES__ADD && !isLocked) {
                this.$nextTick(() => {
                    this.$refs.deviceIdField.focus();
                });
            }
        },

        '$route.path'() {
            if (this.$router.currentRoute.name === ROUTE_NAMES.WIRELESS_MODULES__ADD) {
                this.$nextTick(() => {
                    this.$refs.deviceIdField.select();
                });
            }
        },
    },

    mounted() {
        this.setFormValid(!this.$v.validationGroup.$invalid);

        this.$watch('$v.validationGroup.$invalid', value => {
            this.setFormValid(!value);
        });

        if (this.$router.currentRoute.name === ROUTE_NAMES.WIRELESS_MODULES__ADD) {
            this.$nextTick(() => {
                this.$refs.deviceIdField.select();
            });
        }
    },

    validations() {
        return {
            value: {
                wireless_id: {
                    minimumLength,
                    deviceId,
                    forbiddenDeviceId: val =>
                        forbiddenDeviceId({
                            val: this.toDecimal(val),
                            isAddForm: this.isAddForm(),
                            value: this.value,
                            list: this.allWirelessModules,
                        }),
                },
                device_type: { minimumLength },
                template_id: { minimumLength },
                name: {
                    forbidden,
                    minimumLength,
                    maximumNameLength,
                },
                name_exists: {
                    inUseNames: () => inUseNames(this.value.name, this.existingWirelessModules),
                },
                location: {
                    location_id: { minimumLength },
                },
            },
            validationGroup: [
                'value.wireless_id',
                'value.device_type',
                'value.template_id',
                'value.name',
                'value.location.location_id',
            ],
        };
    },

    methods: {
        errorDisplay,

        isAddForm() {
            return this.$route.name === ROUTE_NAMES.WIRELESS_MODULES__ADD;
        },

        isEditForm() {
            return this.$route.name === ROUTE_NAMES.WIRELESS_MODULES__EDIT;
        },

        setPoints(val) {
            let version;
            if (val && val.length === 6) {
                version =
                    val[0].toString() +
                    val[1].toString() +
                    '.' +
                    val[2].toString() +
                    val[3].toString() +
                    '.' +
                    val[4].toString() +
                    val[5].toString();
            } else {
                version = val;
            }
            return version;
        },

        orderedByName(list) {
            return orderBy(list, 'name');
        },

        updateFormMode(val) {
            this.$emit('updateMode', val);
        },

        update(field, item) {
            this.$emit('input', { ...this.value, [field]: item });
        },
    },
};
</script>
